import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { FileText } from 'lucide-react';
import AdminLayout from '../components/AdminLayout';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminQuotes = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchQuotes();
  }, []);

  const fetchQuotes = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/quotes?limit=1000`);
      setQuotes(response.data.quotes || []);
    } catch (error) {
      toast.error('Failed to load quotes');
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const colors = {
      sent: 'bg-blue-100 text-blue-800',
      viewed: 'bg-yellow-100 text-yellow-800',
      accepted: 'bg-green-100 text-green-800',
      declined: 'bg-red-100 text-red-800'
    };
    return <Badge className={colors[status] || ''}>{status}</Badge>;
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground mb-2">Quote Management</h1>
          <p className="text-muted-foreground">View all quote requests and proposals</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Quotes ({quotes.length})</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-muted/50 border-b">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-medium">Quote #</th>
                    <th className="px-4 py-3 text-left text-sm font-medium">Total</th>
                    <th className="px-4 py-3 text-left text-sm font-medium">Status</th>
                    <th className="px-4 py-3 text-left text-sm font-medium">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="4" className="text-center py-8">Loading...</td></tr>
                  ) : quotes.length === 0 ? (
                    <tr><td colSpan="4" className="text-center py-8">No quotes found</td></tr>
                  ) : (
                    quotes.map((quote) => (
                      <tr key={quote.id} className="border-b hover:bg-muted/30">
                        <td className="px-4 py-3 font-mono">{quote.quote_number}</td>
                        <td className="px-4 py-3 font-semibold">${quote.total?.toFixed(2)}</td>
                        <td className="px-4 py-3">{getStatusBadge(quote.status)}</td>
                        <td className="px-4 py-3 text-sm text-muted-foreground">
                          {new Date(quote.created_at).toLocaleDateString()}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};

export default AdminQuotes;